<script>
    import '$lib/styles/app.scss'
    import '$lib/styles/typography.scss'
    import Heading from '$lib/Components/Heading/Heading.svelte'
    import Alerts from '$lib/Components/Alerts.svelte'
    import GDPRCookieConsent from '$lib/Components/GDPRCookieConsent.svelte'
    import { _, locale } from 'svelte-i18n'
    import AboutMobilePaymentSection from '$lib/Components/AboutMobilePaymentSection.svelte'
    import { navigating } from '$app/stores'
    import LoadingSpinner from '$lib/Components/LoadingSpinner.svelte'
</script>

<div class="container">
    <div class="row justify-content-center">
        <div class="col-xl-6 col-lg-8 col-md-10">
            <Heading />

            <Alerts />

            <div class="card pt-4 px-0 pb-0 mb-5">
                <main class="mb-3 px-3 pb-4">
                    {#if $navigating}
                        <LoadingSpinner delay={150} />
                    {:else}
                        <slot />
                    {/if}
                </main>
            </div>

            <AboutMobilePaymentSection />

            <footer class="py-4 text-center text-secondary small">
                <a href={`/${$locale}/about`} class="text-secondary">{$_('page.about.title')}</a>
                -
                <a href={`/${$locale}/return-policy`} class="text-secondary">{$_('page.return_policy.title')}</a>
                -
                <a
                    href="https://www.sirumobile.com/terms-and-conditions"
                    class="text-secondary"
                    target="_blank"
                    rel="noopener">{$_('phrase.terms_and_conditions')}</a
                >
                -
                <a
                    href="https://www.sirumobile.com/privacy-policy"
                    class="text-secondary"
                    target="_blank"
                    rel="noopener">{$_('phrase.privacy_policy')}</a
                >
                <br />
                &copy; Siru Mobile {new Date().getFullYear()}
            </footer>
        </div>
    </div>
</div>

<GDPRCookieConsent />

<style lang="scss">
    .card {
        box-shadow:
            0 4px 8px 0 rgba(0, 0, 0, 0.2),
            0 6px 20px 0 rgba(0, 0, 0, 0.19);
        border-radius: 0.5em;

        background-color: white;
        text-align: center;

        @media (min-width: 576px) {
            padding-left: 50px;
            padding-right: 50px;
        }

        @media (max-width: 575px) {
            padding-left: 25px;
            padding-right: 25px;
            margin-left: -15px;
            margin-right: -15px;
            box-shadow: none;
            border-radius: 0;
            border: none;
            -webkit-box-shadow: none;
        }
    }

    footer a {
        text-decoration: none;
    }
    footer a:hover {
        text-decoration: underline;
    }

    .mobile-payment-section {
        background-image: url('$lib/images/phone_hands.jpg');
        background-blend-mode: darken;
        background-size: cover;
        background-position: center;
        text-shadow: 2px 2px 15px var(--bs-black);
    }
</style>
